// extracted by mini-css-extract-plugin
export var cardHeader = "_el-0";
export var reorderHandle = "_el-3";
export var titleArea = "_el-1";
export var titleAreaWithHandle = "_el-2";